const formatTimeRead = () => {
    const date = new Date();
    const month = date.toLocaleString('default', { month: 'short' }).toLowerCase();
    const day = date.getDate();
    const year = date.getFullYear();

    const formatted = `${month}-${day}-${year}`;

    return formatted
}

export default formatTimeRead;